import InvitedMembersList from "./InvitedMembersList";
import CloneModal from "./CloneModal";
import { UserAuth } from "../Context";
import Settings from "./Settings";
import CartModal from "../Modals/CartModal";
import useModalStore from "../StatesStore/ModalStore";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  increment,
  updateDoc,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import useFavStore from "../StatesStore/FavStore";
import ListShareMenu from "../components/ListShareMenu";
import { getBaseURL } from "../lib/getBaseURL";
import RenameModal from "./RenameModal";
import useChatClient from "../StatesStore/ChatClient";
import { useParams } from "react-router-dom";
import InvitePeople from "./InvitePeople";
import { useEffect, useState } from "react";
import BottomTray from "../Trays/BottomTray";
import DeleteList from "../Trays/DeleteList";
import RenameList from "../Trays/RenameList";
import PrivacyControls from "../Trays/PrivacyControls";
const ShopListMoreUserProfile = ({
  list,
  shoppingListData,
  setShoppingListData,
  setLoading,
  BackgroundOnSvg,
  setActiveAccordion,
  showShareButton,
  showInviteButton,
  imageWidth = "32px",
  svgWidth = "15px",
  type,
  ownerId,
  componentName,
}) => {
  const { user } = UserAuth();
  const { uid } = useParams();
  const client = useChatClient((state) => state.client);
  const { openModal } = useModalStore();
  const removeFavoriteProduct = useFavStore((state) => state.removeFavorite);
  const favoriteProduct = useFavStore((state) => state.favorites);
  const baseURL = getBaseURL();
  const isCurrentUserProfile = uid === user?.uid;
  const [isOpenDeleteTray, setIsOpenDeleteTray] = useState(false);
  const [isOpenRenameTray, setIsOpenRenameTray] = useState(false);
  const [isOpenPrivacyTray, setIsOpenPrivacyTray] = useState(false);
  const [isOpenManageMembers, setIsOpenManageMembers] = useState(false);
  const [isOpenInvitePeople, setIsOpenInvitePeople] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });
  const closeOtherDropdown = () => {
    let dropdowns = document.getElementsByClassName(`Other`);
    dropdowns.forEach((dropdown) => {
      if (dropdown.classList.contains(list?.listId)) {
        if (dropdown.classList.contains("show")) {
          dropdown.classList.remove("show");
          dropdown.children[0].classList.remove("show");
          dropdown.children[0].ariaExpanded = "false";
          dropdown.children[1].classList.remove("show");
        } else {
          dropdown.classList.add("show");
          dropdown.children[0].classList.add("show");
          dropdown.children[0].ariaExpanded = "true";
          dropdown.children[1].classList.add("show");
        }
      } else {
        dropdown.classList.remove("show");
        dropdown.children[0].classList.remove("show");
        dropdown.children[0].ariaExpanded = "false";
        dropdown.children[1].classList.remove("show");
      }
    });
  };
  const handleClick = () => {
    const DATA = {
      deleteFunction: handleDeleteList,
      displayName: list?.name,
    };
    openModal("ConfirmDelete", "Shopping List", DATA);
  };
  const handleDeleteList = async () => {
    if (!user) return;

    try {
      const selectedShoppingListDoc = doc(
        db,
        "users",
        user?.uid,
        "shoppingList",
        list?.id
      );

      // Get the listId before deleting the shopping list
      const listId = list?.listId;

      if (!listId) throw new Error("ListId not found.");

      // Fetch all member document IDs from the "members" subcollection
      const membersCollectionRef = collection(
        selectedShoppingListDoc,
        "members"
      );
      const membersSnap = await getDocs(membersCollectionRef);
      const memberIds = membersSnap.docs.map((doc) => doc.id);

      // For each member ID, delete the corresponding document from their "invitedList" subcollection
      const deleteInvitedListPromises = memberIds.map(async (memberId) => {
        const invitedListDoc = doc(
          db,
          "users",
          memberId,
          "invitedList",
          listId
        );
        await deleteDoc(invitedListDoc);
        console.log(
          `Deleted listId ${listId} from user ${memberId}'s invitedList`
        );
      });

      await Promise.all(deleteInvitedListPromises);

      console.log("All related documents deleted successfully.");

      // Fetch the product count for the shopping list
      const docCountRef = collection(selectedShoppingListDoc, "products");
      const docCountSnap = await getDocs(docCountRef);
      const countDocs = docCountSnap.size;

      await Promise.all(
        docCountSnap.docs.map(async (doc) => {
          const productRef = doc.ref;
          await deleteDoc(productRef);
        })
      );
      // Remove favorite products
      // eslint-disable-next-line
      favoriteProduct.map((favProd) => {
        removeFavoriteProduct(favProd);
      });
      console.log(favoriteProduct);

      // Update the local state by removing the deleted list
      const remainingLists = shoppingListData?.filter(
        (li) => li?.name !== list?.name
      );

      // Sort the remaining lists by dateCreated in descending order
      remainingLists.sort((a, b) => a.dateCreated - b.dateCreated);

      // Update the local state
      setShoppingListData(remainingLists);

      // Update the user document with the decremented count
      const userRef = doc(db, "users", user?.uid);
      await updateDoc(userRef, {
        shoppingListCount: increment(-countDocs),
      });

      const chatsRef = doc(db, "chats", listId);
      await deleteDoc(chatsRef);
      setActiveAccordion([]);
      console.log("Before client component", client);

      //   try {
      //   if (client) {
      //     // Determine the channel type based on your logic
      //     const channelType = "team"; // or "messaging" - adjust based on your channel type logic
      //     const channel = client.channel(channelType, listId);

      //     // Delete the channel from Stream Chat
      //     await channel.delete();
      //     console.log(`Stream Chat channel ${listId} deleted successfully`);
      //   }
      // } catch (channelError) {
      //   console.error("Error deleting Stream Chat channel:", channelError);
      //   // Don't throw here as we want to continue with the rest of the deletion
      // }
      // Delete the shopping list document
      await deleteDoc(selectedShoppingListDoc);
      console.log("Shopping list deleted successfully");
      console.log("State and Firestore updated successfully.");
    } catch (error) {
      console.error("Error deleting the shopping list:", error.message);
    }
  };
  return (
    <>
      <style jsx>
        {`
          .buttonStyle {
            padding: 10px 16px;
          }
          .buttonStyle:hover {
            backgroundcolor: #e9eaed;
          }
        `}
      </style>
      <div
        onClick={(e) => e.stopPropagation()}
        className={`dropdown ${list?.listId} Other`}
      >
        <div
          className={`p-0 dropdown-toggle`}
          role="button"
          id={`${list?.listId}Dropdown`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
          onClick={() => {
            closeOtherDropdown();
          }}
        >
          <div
            style={{
              width: imageWidth,
              height: imageWidth,
            }}
            className="d-flex align-items-center justify-content-end"
          >
            <svg
              style={{
                width: svgWidth,
                height: svgWidth,
              }}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99712 5.83333C9.07662 5.83333 8.33045 5.08714 8.33045 4.16667C8.33046 3.24619 9.07662 2.5 9.99712 2.5C10.9176 2.5 11.6638 3.24619 11.6638 4.16667C11.6638 5.08714 10.9176 5.83333 9.99712 5.83333Z"
                fill="#14191F"
              />
              <path
                d="M10 11.6666C9.07952 11.6666 8.33335 10.9205 8.33335 9.99998C8.33335 9.07948 9.07952 8.33331 10 8.33331C10.9205 8.33331 11.6667 9.07948 11.6667 9.99998C11.6667 10.9205 10.9205 11.6666 10 11.6666Z"
                fill="#14191F"
              />
              <path
                d="M9.99712 17.5C9.07662 17.5 8.33045 16.7538 8.33045 15.8333C8.33046 14.9128 9.07662 14.1666 9.99712 14.1666C10.9176 14.1666 11.6638 14.9128 11.6638 15.8333C11.6638 16.7538 10.9176 17.5 9.99712 17.5Z"
                fill="#14191F"
              />
            </svg>
          </div>
        </div>
        <ul
          className="dropdown-menu dropdown-menu-end mt-0 py-2"
          aria-labelledby={`${list?.listId}Dropdown`}
          style={{
            cursor: "pointer",
            fontSize: "18px",
            fontWeight: 500,
            fontFamily: "Inter",
            borderRadius: "16px",
            color: "#667085",
            width: "260px",
            boxShadow: "0px 0px 8px 0px #00000026",
          }}
        >
          {/* Invite Button */}
          {/* Share Button */}
          {/* <li
            className="buttonStyle"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <CloneModal
              list={list}
              listName={list?.name}
              userId={user?.uid}
              shoppingListData={shoppingListData}
              setShoppingListData={setShoppingListData}
              setLoading={setLoading}
              BackgroundOnSvg={BackgroundOnSvg}
              closeOtherDropdown={closeOtherDropdown}
              disable={list?.products?.length === 0}
            />
          </li> */}
          {componentName === "ShopListCard" &&
            (showInviteButton || isCurrentUserProfile) && (
              <li
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                  onClick={() => {
                    setIsOpenInvitePeople(true);
                    closeOtherDropdown();
                  }}
                >
                  <BackgroundOnSvg>
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.9166 12C16.1258 12 17.9166 10.433 17.9166 8.5C17.9166 6.567 16.1258 5 13.9166 5C11.7075 5 9.91663 6.567 9.91663 8.5C9.91663 10.433 11.7075 12 13.9166 12Z"
                        stroke="#667085"
                        stroke-width="1.2"
                      />
                      <path
                        d="M23.9166 12H21.9166M21.9166 12H19.9166M21.9166 12V10M21.9166 12V14"
                        stroke="#667085"
                        stroke-width="1.2"
                        stroke-linecap="round"
                      />
                      <path
                        d="M20.9144 19.4444C20.9166 19.2985 20.9166 19.1502 20.9166 19C20.9166 16.7908 17.7826 15 13.9166 15C10.0506 15 6.91663 16.7908 6.91663 19C6.91663 21.2092 6.91663 23 13.9166 23C15.8688 23 17.2765 22.8607 18.2916 22.6119"
                        stroke="#667085"
                        stroke-width="1.2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </BackgroundOnSvg>

                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                      color: "#667085",
                    }}
                  >
                    Invite
                  </span>
                </div>
              </li>
            )}
          {/* {showShareButton && (
            <li
              className="buttonStyle"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <ListShareMenu
                list={list}
                listName={list?.name}
                myName={user?.displayName}
                listLink={`${baseURL}/#/shoppingList/${list?.listId}/${list?.userId}`}
                listId={list?.listId}
                userId={user?.uid}
                products={list?.products}
                BackgroundOnSvg={BackgroundOnSvg}
                componentName={"shopListMore"}
                closeOtherDropdown={closeOtherDropdown}
              />
            </li>
          )} */}

          {/* <li className="buttonStyle" onClick={(e) => {e.stopPropagation();}}>
          <CartModal
            listName={list?.name}
            listProducts={list?.products}
            userId={user?.uid}
            BackgroundOnSvg={BackgroundOnSvg}
            closeOtherDropdown={closeOtherDropdown}
          />
        </li> */}
          {type === "myList" && isCurrentUserProfile && (
            <>
              <li
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {isSmallScreen ? (
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "12px" }}
                    onClick={() => {
                      setIsOpenPrivacyTray(true);
                      closeOtherDropdown();
                    }}
                  >
                    <BackgroundOnSvg>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.8125 15.0521C14.734 16.2928 13.2871 17.1561 11.6832 17.5161C10.0792 17.8761 8.40215 17.7139 6.89691 17.0532C5.39167 16.3923 4.13713 15.2675 3.31649 13.8431C2.49586 12.4186 2.15211 10.7691 2.33545 9.13546C2.51864 7.50165 3.21941 5.96919 4.33541 4.76193C5.4514 3.55467 6.92416 2.73585 8.53857 2.42505M11.4584 2.4313C12.5425 2.64009 13.5691 3.07933 14.4688 3.71929C15.3684 4.35925 16.1201 5.18501 16.6729 6.14067C17.2258 7.09635 17.567 8.15965 17.6733 9.25861C17.7796 10.3576 17.6486 11.4665 17.2891 12.5105"
                          stroke="#676A79"
                          stroke-linecap="round"
                        />
                        <path
                          d="M8.33337 9.58337V8.09379C8.33337 7.19056 9.07952 6.45837 10 6.45837C10.9206 6.45837 11.6667 7.19056 11.6667 8.09379V9.58337M7.91671 9.58337H12.0834C12.545 9.58337 12.9167 9.95504 12.9167 10.4167V12.7084C12.9167 13.17 12.545 13.5417 12.0834 13.5417H7.91671C7.45504 13.5417 7.08337 13.17 7.08337 12.7084V10.4167C7.08337 9.95504 7.45504 9.58337 7.91671 9.58337Z"
                          stroke="#676A79"
                        />
                      </svg>
                    </BackgroundOnSvg>

                    <span
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "18px",
                        lineHeight: "100%",
                        letterSpacing: "0px",
                      }}
                    >
                      Privacy Controls
                    </span>
                  </div>
                ) : (
                  <Settings
                    selectedShopList={list?.name}
                    BackgroundOnSvg={BackgroundOnSvg}
                    closeOtherDropdown={closeOtherDropdown}
                  />
                )}
              </li>
              <li
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                  onClick={() => {
                    setIsOpenManageMembers(true);
                    closeOtherDropdown();
                  }}
                >
                  <BackgroundOnSvg>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10 6.875C8.27412 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27412 13.125 10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875ZM8.125 10C8.125 8.9645 8.9645 8.125 10 8.125C11.0355 8.125 11.875 8.9645 11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.9645 11.875 8.125 11.0355 8.125 10Z"
                        fill="#676A79"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.97896 1.04163C9.60862 1.04162 9.29937 1.04162 9.04554 1.05893C8.78129 1.07697 8.53171 1.11583 8.28972 1.21607C7.7282 1.44866 7.28207 1.89478 7.04948 2.45631C6.92839 2.74864 6.8956 3.05673 6.88307 3.39159C6.87301 3.66078 6.73716 3.88538 6.53667 4.00113C6.33618 4.11688 6.07375 4.12223 5.83559 3.99636C5.53932 3.83977 5.25612 3.71412 4.9424 3.67282C4.33982 3.59348 3.73039 3.75678 3.2482 4.12678C3.0404 4.28623 2.88193 4.48296 2.7342 4.70279C2.59228 4.91397 2.43768 5.18175 2.25249 5.50252L2.23145 5.53897C2.04625 5.85973 1.89165 6.12749 1.77973 6.35598C1.66322 6.59385 1.57208 6.82945 1.53788 7.08913C1.45855 7.69173 1.62185 8.30114 1.99184 8.78337C2.18444 9.03429 2.43482 9.21679 2.71852 9.39504C2.94667 9.53837 3.07328 9.76837 3.07326 9.99996C3.07325 10.2315 2.94664 10.4615 2.71852 10.6048C2.43478 10.783 2.18438 10.9655 1.99177 11.2165C1.62177 11.6987 1.45848 12.3081 1.5378 12.9107C1.57199 13.1704 1.66313 13.406 1.77964 13.6439C1.89157 13.8724 2.04617 14.1401 2.23136 14.4609L2.25241 14.4974C2.4376 14.8181 2.59219 15.0859 2.73412 15.297C2.88185 15.5169 3.04032 15.7136 3.24812 15.873C3.73031 16.243 4.33973 16.4064 4.94232 16.327C5.25602 16.2857 5.53921 16.1601 5.83546 16.0035C6.07365 15.8776 6.33612 15.883 6.53663 15.9988C6.73714 16.1145 6.87301 16.3391 6.88307 16.6084C6.8956 16.9432 6.9284 17.2513 7.04948 17.5436C7.28207 18.1051 7.7282 18.5513 8.28972 18.7839C8.53171 18.8841 8.78129 18.923 9.04554 18.941C9.29937 18.9583 9.60862 18.9583 9.97896 18.9583H10.021C10.3915 18.9583 10.7006 18.9583 10.9545 18.941C11.2188 18.923 11.4684 18.8841 11.7104 18.7839C12.2719 18.5513 12.718 18.1051 12.9506 17.5436C13.0717 17.2513 13.1045 16.9432 13.117 16.6083C13.127 16.3391 13.2629 16.1145 13.4634 15.9987C13.6639 15.883 13.9264 15.8776 14.1645 16.0035C14.4608 16.16 14.744 16.2857 15.0577 16.327C15.6603 16.4063 16.2697 16.243 16.7519 15.873C16.9597 15.7135 17.1181 15.5169 17.2659 15.297C17.4078 15.0859 17.5624 14.8181 17.7475 14.4974L17.7686 14.4609C17.9538 14.1401 18.1085 13.8723 18.2204 13.6438C18.3369 13.406 18.428 13.1704 18.4622 12.9107C18.5415 12.308 18.3782 11.6986 18.0082 11.2165C17.8156 10.9655 17.5652 10.783 17.2815 10.6048C17.0534 10.4615 16.9268 10.2315 16.9268 9.99987C16.9268 9.76837 17.0534 9.53846 17.2815 9.39513C17.5653 9.21688 17.8157 9.03446 18.0083 8.78337C18.3783 8.3012 18.5416 7.69178 18.4623 7.08919C18.428 6.82951 18.337 6.59391 18.2205 6.35604C18.1085 6.12757 17.954 5.85982 17.7687 5.53908L17.7477 5.50261C17.5625 5.18183 17.4079 4.91403 17.266 4.70285C17.1182 4.48302 16.9598 4.28629 16.752 4.12683C16.2698 3.75684 15.6604 3.59354 15.0577 3.67288C14.744 3.71418 14.4609 3.83981 14.1646 3.99639C13.9265 4.12228 13.664 4.11693 13.4635 4.00116C13.263 3.8854 13.127 3.66077 13.117 3.39155C13.1045 3.05669 13.0717 2.74863 12.9506 2.45631C12.718 1.89478 12.2719 1.44866 11.7104 1.21607C11.4684 1.11583 11.2188 1.07697 10.9545 1.05893C10.7006 1.04162 10.3915 1.04162 10.021 1.04163H9.97896ZM8.76804 2.37092C8.83237 2.34428 8.93004 2.31973 9.13062 2.30603C9.33687 2.29197 9.60321 2.29163 10 2.29163C10.3969 2.29163 10.6632 2.29197 10.8694 2.30603C11.07 2.31973 11.1677 2.34428 11.232 2.37092C11.4872 2.47664 11.69 2.67943 11.7957 2.93467C11.8291 3.01518 11.8567 3.14068 11.8679 3.43827C11.8925 4.09858 12.2334 4.73437 12.8385 5.08369C13.4435 5.43303 14.1645 5.41029 14.7487 5.10153C15.012 4.96238 15.1345 4.92356 15.2209 4.91218C15.4948 4.87613 15.7718 4.95035 15.991 5.11853C16.0462 5.16089 16.1163 5.2332 16.2285 5.40009C16.3438 5.57165 16.4772 5.80213 16.6756 6.14579C16.874 6.48947 17.007 6.72028 17.0979 6.9059C17.1863 7.08648 17.2139 7.18335 17.223 7.25235C17.259 7.52625 17.1848 7.80327 17.0166 8.02244C16.9635 8.09158 16.8687 8.17828 16.6165 8.33671C16.057 8.68829 15.6769 9.30129 15.6768 9.99987C15.6768 10.6985 16.057 11.3116 16.6165 11.6632C16.8686 11.8216 16.9635 11.9083 17.0165 11.9775C17.1847 12.1966 17.259 12.4736 17.2229 12.7475C17.2138 12.8165 17.1862 12.9134 17.0978 13.094C17.0069 13.2795 16.874 13.5104 16.6755 13.854C16.4771 14.1977 16.3437 14.4282 16.2284 14.5998C16.1162 14.7666 16.0461 14.839 15.9909 14.8813C15.7717 15.0495 15.4947 15.1237 15.2208 15.0877C15.1345 15.0763 15.0119 15.0375 14.7486 14.8984C14.1645 14.5895 13.4434 14.5669 12.8383 14.9162C12.2334 15.2655 11.8925 15.9013 11.8679 16.5616C11.8567 16.8592 11.8291 16.9847 11.7957 17.0653C11.69 17.3205 11.4872 17.5233 11.232 17.629C11.1677 17.6556 11.07 17.6802 10.8694 17.6939C10.6632 17.708 10.3969 17.7083 10 17.7083C9.60321 17.7083 9.33687 17.708 9.13062 17.6939C8.93004 17.6802 8.83237 17.6556 8.76804 17.629C8.51287 17.5233 8.31005 17.3205 8.20433 17.0653C8.17098 16.9847 8.14333 16.8592 8.1322 16.5616C8.10751 15.9014 7.76668 15.2655 7.16162 14.9162C6.55657 14.5669 5.83556 14.5896 5.25136 14.8984C4.98808 15.0375 4.86557 15.0764 4.77917 15.0877C4.50526 15.1238 4.22825 15.0495 4.00908 14.8814C3.95386 14.839 3.88375 14.7667 3.77159 14.5998C3.6563 14.4283 3.52284 14.1978 3.32443 13.8541C3.126 13.5105 2.99313 13.2796 2.90221 13.094C2.81376 12.9135 2.78619 12.8165 2.77711 12.7475C2.74105 12.4736 2.81528 12.1966 2.98346 11.9775C3.03651 11.9084 3.13138 11.8216 3.38354 11.6632C3.94303 11.3117 4.32323 10.6986 4.32326 10C4.3233 9.30129 3.94308 8.68821 3.38355 8.33662C3.13145 8.1782 3.03658 8.09152 2.98353 8.02238C2.81536 7.80321 2.74113 7.5262 2.77719 7.25229C2.78628 7.1833 2.81384 7.08642 2.90229 6.90585C2.99322 6.72022 3.12608 6.48941 3.3245 6.14573C3.52293 5.80207 3.65638 5.57159 3.77168 5.40003C3.88383 5.23315 3.95394 5.16083 4.00915 5.11848C4.22833 4.95029 4.50534 4.87607 4.77924 4.91213C4.86565 4.9235 4.98818 4.96232 5.25148 5.10149C5.83565 5.41025 6.55663 5.43298 7.16166 5.08367C7.76669 4.73436 8.10751 4.0986 8.1322 3.43831C8.14333 3.1407 8.17098 3.01518 8.20433 2.93467C8.31005 2.67943 8.51287 2.47664 8.76804 2.37092Z"
                        fill="#676A79"
                      />
                    </svg>
                  </BackgroundOnSvg>
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                    }}
                  >
                    Manage Members
                  </span>
                </div>
              </li>
              <li
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {isSmallScreen ? (
                  <div
                    onClick={() => {
                      setIsOpenRenameTray(true);
                      closeOtherDropdown();
                    }}
                    className="d-flex align-items-center"
                    style={{ gap: "12px" }}
                  >
                    <BackgroundOnSvg>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.39289 1.42859C8.09703 1.42859 7.85718 1.66844 7.85718 1.9643C7.85718 2.26017 8.09703 2.50002 8.39289 2.50002H9.46432V17.5H8.39289C8.09703 17.5 7.85718 17.7399 7.85718 18.0357C7.85718 18.3316 8.09703 18.5714 8.39289 18.5714H11.6072C11.903 18.5714 12.1429 18.3316 12.1429 18.0357C12.1429 17.7399 11.903 17.5 11.6072 17.5H10.5357V2.50002H11.6072C11.903 2.50002 12.1429 2.26017 12.1429 1.9643C12.1429 1.66844 11.903 1.42859 11.6072 1.42859H8.39289Z"
                          fill="#676A79"
                        />
                        <path
                          d="M4.46425 4.29968H8.74996V5.37111H4.46425C3.77389 5.37111 3.21425 5.93075 3.21425 6.62111V13.4068C3.21425 14.0972 3.77389 14.6568 4.46425 14.6568H8.74996V15.7283H4.46425C3.18216 15.7283 2.14282 14.6889 2.14282 13.4068V6.62111C2.14282 5.33902 3.18216 4.29968 4.46425 4.29968Z"
                          fill="#676A79"
                        />
                        <path
                          d="M15.5357 14.6568H11.25V15.7283H15.5357C16.8178 15.7283 17.8571 14.6889 17.8571 13.4068V6.62111C17.8571 5.33902 16.8178 4.29968 15.5357 4.29968H11.25V5.37111H15.5357C16.2261 5.37111 16.7857 5.93075 16.7857 6.62111V13.4068C16.7857 14.0972 16.2261 14.6568 15.5357 14.6568Z"
                          fill="#676A79"
                        />
                      </svg>
                    </BackgroundOnSvg>
                    <span
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "18px",
                        lineHeight: "100%",
                        letterSpacing: "0px",
                      }}
                    >
                      Rename List
                    </span>
                  </div>
                ) : (
                  <RenameModal
                    BackgroundOnSvg={BackgroundOnSvg}
                    list={list}
                    closeOtherDropdown={closeOtherDropdown}
                  />
                )}
              </li>

              <li
                style={{
                  borderRadius: "0px 0px 16px 16px",
                }}
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                  onClick={() => {
                    if (isSmallScreen) {
                      setIsOpenDeleteTray(true);
                      closeOtherDropdown();
                    } else {
                      handleClick();
                      closeOtherDropdown();
                    }
                  }}
                >
                  <BackgroundOnSvg>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.16671 16.6665C4.16671 17.5832 4.91671 18.3332 5.83337 18.3332H14.1667C15.0834 18.3332 15.8334 17.5832 15.8334 16.6665V4.99984H4.16671V16.6665ZM5.83337 6.6665H14.1667V16.6665H5.83337V6.6665ZM13.75 2.49984L12.9167 1.6665H7.08337L6.25004 2.49984H3.33337V4.1665H16.6667V2.49984H13.75ZM10.8334 14.9998V8.33317H12.5V14.9998H10.8334ZM7.50004 8.33317L7.50004 14.9998H9.16671V8.33317H7.50004Z"
                        fill="#FF3742"
                      />
                    </svg>
                  </BackgroundOnSvg>

                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                      color: "#FF3742",
                    }}
                  >
                    Delete List
                  </span>
                </div>
              </li>
            </>
          )}
        </ul>
      </div>
      <InvitePeople
        selectedShopList={list}
        listId={list?.listId}
        listName={list?.name}
        myName={user?.displayName}
        ownerId={ownerId}
        listLink={`${baseURL}/#/shoppingList/${list?.listId}/${
          type === "myList" ? user?.uid : list?.userId
        }`}
        componentName={"shopListMore"}
        BackgroundOnSvg={BackgroundOnSvg}
        closeOtherDropdown={closeOtherDropdown}
        isOpen={isOpenInvitePeople}
        setIsOpen={setIsOpenInvitePeople}
      />
      <BottomTray
        text={"Edit List Privacy"}
        isOpen={isOpenPrivacyTray}
        setIsOpen={setIsOpenPrivacyTray}
      >
        <PrivacyControls selectedShopList={list?.name} />
      </BottomTray>
      <InvitedMembersList
        listName={list.id}
        userId={user?.uid}
        listId={list.listId}
        BackgroundOnSvg={BackgroundOnSvg}
        componentName={"shopListMore"}
        closeOtherDropdown={closeOtherDropdown}
        isOpen={isOpenManageMembers}
        setIsOpen={setIsOpenManageMembers}
      />
      <BottomTray
        text={"Rename Shopping List"}
        isOpen={isOpenRenameTray}
        setIsOpen={setIsOpenRenameTray}
      >
        <RenameList list={list} />
      </BottomTray>
      <BottomTray
        text={"Delete List"}
        isOpen={isOpenDeleteTray}
        setIsOpen={setIsOpenDeleteTray}
      >
        <DeleteList handleDeleteList={handleDeleteList} listName={list?.name} />
      </BottomTray>
    </>
  );
};

export default ShopListMoreUserProfile;
